export default __webpack_public_path__ + "static/media/plus.25941b8e.svg";